import { CanActivateFn } from '@angular/router';
import { AppSessionStorageService } from '../services/utils/session-storage.service';
import { inject } from '@angular/core';
import { WebService } from '../services/web/web.service';
import { RouteConstants } from '../constants/route-constants';

export const loginGuard: CanActivateFn = async (_, __) => {
  const service = inject(WebService);
  await service.callKeyGenerateApi();
  if (
    AppSessionStorageService.isLoggedIn() &&
    AppSessionStorageService.auth?.role == 'installer'
  ) {
    service.router.navigate([RouteConstants.INSTALLER_DASHBOARD]);
    return false;
  }
  if (
    AppSessionStorageService.isLoggedIn() &&
    AppSessionStorageService.auth?.role == 'administrator'
  ) {
    service.router.navigate([RouteConstants.ADMIN_DASHBOARD]);
    return false;
  }
  return true;
};
